import {useNotificationContext} from "@/components/Contexts/NotificationContext.tsx";
import React, {useEffect, useState} from "react";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CloseIcon from "@mui/icons-material/Close";
import {t} from "i18next";
import {Button} from "@/components/ui/button.tsx";
import {Minus, PlusIcon} from "lucide-react";

export default function ProgressDialog() {
  const [open, setOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);
  const context = useNotificationContext();
  const steps = context.stepProgress;
  const currentItem = steps?.length ? steps[steps.length - 1] : null;
  const tenantId = window.location.pathname.split('/')[1];
  const progressPercentage = Math.round((currentItem?.Step / currentItem?.TotalSteps) * 100);

  useEffect(() => {
    setOpen(context.executing);
  }, [context.executing]);

  return (
    context.stepProgress.length > 0 ?
      (
        <>
          {open && context.executing && context.clientName === tenantId ? (
            !minimized ? (
              <div className="fixed right-10 flex max-h-fit w-fit gap-4 bg-inProgess p-4 text-base" style={{ zIndex: 9999 }}>
                <AutorenewIcon className="w-5 animate-spin text-white" />
                <div className="flex-col text-sm text-white">
                  <div className="text-sm font-semibold">{t(currentItem?.Title)}</div>
                  <div className="mt-4 h-2 w-full bg-in-progress-bar">
                    <div
                      className="h-2 bg-white"
                      style={{ width: progressPercentage + '%' }}
                    ></div>
                  </div>
                  <div className="mt-4 text-sm font-semibold">
                    {t(currentItem?.Subtitle)} ({currentItem?.Step}/{currentItem?.TotalSteps})
                  </div>
                  <div className="flex justify-between gap-x-36 mt-2">
                    <div className="mt-4 text-sm">
                      {t('Process.NextJob')}: <span className="font-semibold">{currentItem?.RemainingJobsCount > 0 ? t(currentItem?.NextJobType) : '-'}</span>
                    </div>
                    <div className="mt-4 text-sm">
                      <span className="font-semibold">{currentItem?.RemainingJobsCount > 0 ? '+' + currentItem?.RemainingJobsCount : 0}</span> {t('Process.QueuedJobs')}
                    </div>
                  </div>
                </div>
                <Minus size={19} onClick={() => setMinimized(true)} className="mt-0.5 cursor-pointer text-white"/>
              </div>
            ) : (
              <div className="fixed right-10 flex max-h-fit w-fit gap-4 bg-inProgess p-4 text-base" style={{ zIndex: 9999 }}>
                <AutorenewIcon className="w-5 animate-spin text-white" />
                <div className="mx-4 flex-col text-sm text-white">
                  <div className="text-sm font-semibold">
                    {t(currentItem?.Subtitle)} ({currentItem?.Step}/{currentItem?.TotalSteps})
                  </div>
                  <div className="mt-4"></div>
                  <div className="mt-4 h-2 w-full bg-in-progress-bar">
                    <div
                      className="h-2 bg-white"
                      style={{ width: progressPercentage + '%' }}
                    ></div>
                  </div>
                </div>
                <PlusIcon size={19} onClick={() => setMinimized(false)} className="mt-0.5 cursor-pointer text-white"/>
              </div>
            )
          ) : (
             <></>
          )}
        </>
      )
      : (
        <>
          {open && context.executing ? (
            <div className="fixed right-10 flex max-h-fit w-fit gap-4 bg-inProgess p-4 text-base" style={{ zIndex: 9999 }}>
              <AutorenewIcon className="w-5 animate-spin text-white" />
              <div className="mx-4 flex-col text-sm text-white">
                <div className="text-sm font-semibold">{t('Generic.Process.LoadingStatus')}</div>
                <div className="mt-4"></div>
                <div className="mt-4 h-2 w-full bg-in-progress-bar">
                  <div
                    className="h-2 bg-white"
                    style={{ width: 0 + '%' }}
                  ></div>
                </div>
                <div className="mt-4 text-sm font-semibold">
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )
  )
}
